import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LocalizationService } from '@core/services/localization.service';
import { Attendance } from '../interfaces/attendance';

@Injectable({
  providedIn: 'root',
})
export class CtaUnreadAttendanceTitleService {
  private _unreadAttendances: Array<Attendance['id']> = [];

  constructor(
    private readonly title: Title,
    private readonly localizationService: LocalizationService
  ) {}

  addUnreadAttendance(attendanceId: Attendance['id']) {
    if (!this._unreadAttendances.includes(attendanceId)) {
      this._unreadAttendances.push(attendanceId);
      this.updateTitle();
    }
  }

  removeUnreadAttendance(attendanceId: Attendance['id']) {
    const index = this._unreadAttendances.indexOf(attendanceId);
    if (index < 0) return;

    this._unreadAttendances.splice(index, 1);
    this.updateTitle();
  }

  resetUnreadAttendances() {
    this._unreadAttendances = [];
    this.updateTitle();
  }

  handleAttendanceUpdate(updatedAttendance: Attendance) {
    !updatedAttendance.stats?.hasUnreadMessages 
      ? this.removeUnreadAttendance(updatedAttendance.id) 
      : this.addUnreadAttendance(updatedAttendance.id);
  }

  handleAttendanceUpdateListUp(updatedAttendance: Attendance, currentAttendance?: Attendance) {
    if (currentAttendance && currentAttendance.id === updatedAttendance.id) return;
    this.handleAttendanceUpdate(updatedAttendance);
  }

  private updateTitle() {
    const counter = this._unreadAttendances.length;
    const title = `${
      counter ? `(${counter})` : ''
    } ${this.localizationService.key('PAGE_TITLE')}`;
    this.title.setTitle(title.trim());
  }
}
